var _jsxFileName = "/builds/zillow/hackweek/military-rent-affordability-calculator/src/components/MilitaryRentAffordabilityCalculator/mrac-income-debt-statement/index.jsx",
    _this = this;

import React from 'react';
import { Paragraph } from '@zillow/constellation';

var Statement = function Statement(_ref) {
  var incomeAndDebt = _ref.incomeAndDebt,
      rent = _ref.rent;
  var rentIncomeRatio = rent / incomeAndDebt.monthlyNetIncomePretax;
  var statement;

  if (rentIncomeRatio > 0.35) {
    statement = /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "md",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9,
        columnNumber: 13
      }
    }, "Careful! Landlords may not allow you to spend more than 33% of your income on rent. Make sure to check first.");
  } else if (rentIncomeRatio > 0.335 && rentIncomeRatio <= 0.35) {
    statement = /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "md",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 13
      }
    }, "Generally, landlords require your rent to be no more than one-third of your gross income.");
  } else {
    statement = /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "md",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 13
      }
    }, "Based on your income, a rental at this price should fit comfortably within your budget.");
  }

  if (incomeAndDebt.monthlyNetIncome - rent - incomeAndDebt.monthlyDebtsAndExpenses < 0) {
    statement = /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "md",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 13
      }
    }, "Careful! If you spend this much on rent, your debts and expenses will exceed your income.");
  }

  return statement;
};

export default Statement;